<template>
  <OrderProvider
    :order-id="orderId"
    :order-date="orderDate"
  >
    <template v-slot:default="{ updateOrder, order, savingProductById, changedProducts }">
      <div class="h-5 my-3 flex justify-center">
        <Spinner v-show="$apollo.queries.products.loading" />
      </div>
      <div v-if="!$apollo.queries.products.loading">
        <p v-if="!items || items.length === 0">
          Keine Produkte gefunden.
        </p>
        <template v-else>
          <Product
            v-for="item in items"
            :key="item.item.id"
            :item="item.item"
            :order="order"
            :in-change-log="changedProducts.findIndex(obj => obj.id === item.item.id) > -1"
            :saving="savingProductById === item.item.id"
            @submit="updateOrder"
          />
        </template>
      </div>
    </template>
  </OrderProvider>
</template>

<script>
import { productsQuery } from './queries'

import filterStore from '@/Store/filter'
import Spinner from '@/Components/Spinner'
import OrderProvider from '@/Components/Product/OrderProvider'
import Product from '@/Components/Product'

import Fuse from 'fuse.js'

export default {
  name: 'ShopIndex',
  components: { OrderProvider, Product, Spinner },
  inject: ['systemStatus'],

  props: {
    orderDate: {
      type: String,
      required: true,
    },
    orderId: {
      type: Number,
      default: null
    },
    categories: {
      type: Array,
      required: true
    },
    tags: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data() {
    return {
      filter: filterStore.state,
      loading: 0,
      saving: 0,
      fuse: new Fuse([], {
        keys: ['name', 'item_number']
      })
    }
  },

  computed: {
    items() {
      if (this.filter.search !== '') {
        return this.fuse.search(this.filter.search)
      }

      const products = this.products.data.map(function (product) {
        return {item: product}
      })

      return products
    }
  },

  beforeCreate() {
    this.fuse = new Fuse([], {
      keys: ['name', 'item_number']
    })
  },

  apollo: {
    products: {
      query: productsQuery,
      variables () {
        return {
          date: this.orderDate,
          categoryId: this.filter.categories.length > 0 ? this.filter.categories[0] : undefined,
          tagIds: this.filter.tags.length > 0 ? this.filter.tags : undefined,
        }
      },
      result ({ data, loading, networkStatus }) {
        this.fuse.setCollection(data.products.data)
      },
    }
  },
}
</script>
